import React from 'react';
import {
  // Eye, Trash2,
  FileText,
  Loader2,
  RefreshCw,
  Clock,
  X,
} from 'lucide-react';
import {
  DocumentItem,
  DocumentIconWrapper,
  DocumentInfo,
  DocumentName,
  DocumentMeta,
  DocumentActions,
  StatusBadge,
  IconButton,
  ProgressBarTrack,
  ProgressBarFill,
  ProgressLabel,
} from '../uploadDocuments.styles';

const DocumentListItem = ({
  doc,
  // onView,
  // onDelete,
  onReupload,
  onSkip,
  // isViewing,
  // isDeleting,
  disabled,
}) => {
  const { status, errorMessage } = doc;

  return (
    <DocumentItem>
      <DocumentIconWrapper>
        <FileText size={20} />
      </DocumentIconWrapper>

      <DocumentInfo>
        <DocumentName title={doc.name}>{doc.name}</DocumentName>
        <DocumentMeta>
          {doc.size}
          {(status === 'error' || status === 'size-error') && errorMessage
            ? ` • ${errorMessage}`
            : null}
        </DocumentMeta>{' '}
        {status === 'uploading' && (
          <ProgressBarTrack aria-label={`Upload progress for ${doc.name}`}>
            <ProgressBarFill style={{ width: `${doc.progress ?? 0}%` }} />
          </ProgressBarTrack>
        )}
      </DocumentInfo>

      <DocumentActions>
        {status === 'pending' && (
          <StatusBadge $status="PENDING">
            <Clock size={12} style={{ marginRight: 4 }} />
            Waiting
          </StatusBadge>
        )}

        {status === 'uploading' && (
          <StatusBadge $status="UPLOADING">
            <Loader2 size={12} className="spin" style={{ marginRight: 4 }} />
            <ProgressLabel>{doc.progress ?? 0}%</ProgressLabel>
          </StatusBadge>
        )}

        {status === 'size-error' && (
          <>
            <StatusBadge $status="ERROR">File Too Large</StatusBadge>
            <IconButton
              onClick={() => onSkip(doc)}
              disabled={disabled}
              title="Skip this file"
              $variant="delete"
              aria-label={`Skip ${doc.name}`}
            >
              <X size={16} />
            </IconButton>
          </>
        )}

        {status === 'error' && (
          <>
            <StatusBadge $status="ERROR">Failed</StatusBadge>
            <IconButton
              onClick={() => onReupload(doc)}
              disabled={disabled}
              title="Retry upload"
              $variant="view"
              aria-label={`Retry upload for ${doc.name}`}
            >
              <RefreshCw size={16} />
            </IconButton>
            <IconButton
              onClick={() => onSkip(doc)}
              disabled={disabled}
              title="Skip this file"
              $variant="delete"
              aria-label={`Skip ${doc.name}`}
            >
              <X size={16} />
            </IconButton>
          </>
        )}

        {status === 'skipped' && (
          <StatusBadge $status="SKIPPED">
            <X size={12} style={{ marginRight: 4 }} />
            Skipped
          </StatusBadge>
        )}

        {status === 'done' && (
          <>
            <StatusBadge $status="READY">READY</StatusBadge>
            {/* <IconButton
              onClick={() => onView(doc)}
              disabled={isViewing || isDeleting || disabled}
              title="View document"
              $variant="view"
              aria-label={`View ${doc.name}`}
            >
              {isViewing ? <Loader2 size={16} className="spin" /> : <Eye size={16} />}
            </IconButton>

            <IconButton
              onClick={() => onDelete(doc)}
              disabled={isViewing || isDeleting || disabled}
              title="Delete document"
              $variant="delete"
              aria-label={`Delete ${doc.name}`}
            >
              {isDeleting ? <Loader2 size={16} className="spin" /> : <Trash2 size={16} />}
            </IconButton> */}
          </>
        )}
      </DocumentActions>
    </DocumentItem>
  );
};

export default DocumentListItem;
